module.exports = __webpack_public_path__ + "static/img/item-3.eb33e851.png";